import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MensajeComponent } from 'src/app/components/shared/mensaje/mensaje.component';
import { ModalTradeMonedaComponent } from 'src/app/components/shared/modal-trade-moneda/modal-trade-moneda.component';

import { ModalTradeComponent } from 'src/app/components/shared/modal-trade/modal-trade.component';
import { ModalBcraComponent } from 'src/app/components/shared/modal-bcra/modal-bcra.component';
import { ModalDoublePreviewComponent } from 'src/app/components/shared/modal-double-preview/modal-double-preview.component';

import { ModalComponent } from 'src/app/components/shared/modal/modal.component';
import { ModalDominioSubdominioComponent } from 'src/app/components/shared/modal-dominio-subdominio/modal-dominio-subdominio.component';

@Injectable({
  providedIn: 'root'
})

export class DialogsService {

  matDialog: MatDialog = null;

  constructor(private dialog: MatDialog) { }

  muestraMensaje(mensaje: string, configuration?: any): Promise<any> {

    const config = configuration ?
      configuration :
      {
        width: '500px',
        data: {
          titulo: mensaje,
          btnCancel: 'Aceptar',
          icon: 'error_outline'
        }
      };
    const component = configuration ? ModalComponent : MensajeComponent;
    const dialogRef = this.dialog.open(component, config);
    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe({
        next: _result => {
          resolve(_result);
        }, error: _error => {
          reject(_error);
        }
      });
    })
  }

  muestraMensajeTrade(mensaje: string, configuration?: any): Promise<any> {
    // Cerrar todos los diálogos abiertos antes de abrir uno nuevo
    this.dialog.closeAll();

    const config = configuration ?
      configuration :
      {
        width: '500px',
        data: {
          titulo: mensaje,
          btnCancel: 'Aceptar',
          icon: 'error_outline'
        }
      };
    const component = configuration ? ModalTradeComponent : MensajeComponent;
    const dialogRef = this.dialog.open(component, config);
    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe({
        next: _result => {
          resolve(_result);
        }, error: _error => {
          reject(_error);
        }
      });
    })
  }

  muestraMensajeDoublePreview(mensaje: string, configuration?: any): Promise<any> {
    const config = configuration ?
      configuration :
      {
        width: '500px',
        data: {
          titulo: mensaje,
          btnCancel: 'Aceptar',
          icon: 'error_outline'
        }
      };
    const component = configuration ? ModalDoublePreviewComponent : MensajeComponent;
    const dialogRef = this.dialog.open(component, config);
    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe({
        next: _result => {
          resolve(_result);
        }, error: _error => {
          reject(_error);
        }
      });
    })
  }

  muestraMensajeMoneda(mensaje: string, configuration?: any): Promise<any> {
    const config = configuration ?
      configuration :
      {
        width: '500px',
        data: {
          titulo: mensaje,
          btnCancel: 'Aceptar',
          icon: 'error_outline'
        }
      };
    const component = configuration ? ModalTradeMonedaComponent : MensajeComponent;
    const dialogRef = this.dialog.open(component, config);
    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe({
        next: _result => {
          resolve(_result);
        }, error: _error => {
          reject(_error);
        }
      });
    })
  }

  muestraMensajeAmbRds(mensaje: string, configuration?: any): Promise<any> {
    const config = configuration ?
      configuration :
      {
        width: '500px',
        data: {
          titulo: mensaje,
          btnCancel: 'Aceptar',
          icon: 'error_outline'
        }
      };
    const component = configuration ? ModalDominioSubdominioComponent : MensajeComponent;
    const dialogRef = this.dialog.open(component, config);
    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe({
        next: _result => {
          resolve(_result);
        }, error: _error => {
          reject(_error);
        }
      });
    })
  }

  muestraMensajeBcra(mensaje: string, configuration?: any): Promise<any> {
    const config = configuration ?
      configuration :
      {
        width: '500px',
        data: {
          titulo: mensaje,
          btnCancel: 'Aceptar',
          icon: 'error_outline'
        }
      };
    const component = configuration ? ModalBcraComponent : MensajeComponent;
    const dialogRef = this.dialog.open(component, config);
    return new Promise((resolve, reject) => {
      dialogRef.afterClosed().subscribe({
        next: _result => {
          resolve(_result);
        }, error: _error => {
          reject(_error);
        }
      });
    })
  }
}
